import React from "react";
import MainContent from "../main-content/MainContent";
import SideBar from "../sidebar/SideBar";

import "./MainContainerCard.scss";

const MainContainerCard = () => {
  const [value, setValue] = React.useState("2");
  return (
    <div className="main-container-card">
      <MainContent setValue={setValue} value={value} />
      <SideBar setValue={setValue} value={value} />
    </div>
  );
};
export default MainContainerCard;
